import { takeEvery } from 'redux-saga/effects';
import { SYSTEM_EVENTS_MODULE } from '../../../configs/moduleNames';
import { DOWNLOAD_SYSTEM_EVENTS, LOAD_SYSTEM_EVENTS } from '../actions';

import loadSystemEvents from './loadSystemEvents';
import downloadSystemEvents from './downloadSystemEvents';

export default function* watchDashboard() {
  yield takeEvery(SYSTEM_EVENTS_MODULE + LOAD_SYSTEM_EVENTS, loadSystemEvents);
  yield takeEvery(SYSTEM_EVENTS_MODULE + DOWNLOAD_SYSTEM_EVENTS, downloadSystemEvents);
}
